import { Box, Card } from '@factorialco/deprecated-design-system'
import { PerformanceTargetInsightsQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { EngagementSignalTag } from 'modules/performance_analytics/components/EngagementSignalTag'

type PerformanceEngagmentSignal = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          PerformanceTargetInsightsQuery['performance']['reviewProcess']
        >['materializeTargetsConnection']
      >['nodes'][number]
    >['insight']
  >['engagementSignals']
>[number]

interface InsightsEngagementSignalsProps {
  engagementSignals: PerformanceEngagmentSignal[]
}

export const InsightsEngagementSignals: React.FC<InsightsEngagementSignalsProps> = ({
  engagementSignals,
}) => {
  return (
    <Box width="full" gridColSpan={{ xxs: 4 }}>
      <Card key={i18n.t('performance_process.insights.titles.engagement_signals')}>
        <Card.Title>{i18n.t('performance_process.insights.titles.engagement_signals')}</Card.Title>
        <Card.Content>
          <Box alignItems="flexStart" gap="s8" flexDirection="row" flexWrap="wrap">
            {engagementSignals.map((signal) => (
              <EngagementSignalTag key={signal.name} engagementSignal={signal} />
            ))}
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
